import {
  DEFAULT_OG_IMAGE_HEIGHT,
  DEFAULT_OG_IMAGE_WIDTH,
  getSectionOgImageUrl,
} from "@config/ogImageConstants";
import { capitalize } from "@helper/stringTransform";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

type KeywordMetaDataProps = {
  tagName: string;
  tagAlias: string;
};

export default function KeywordMetaData({
  tagName,
  tagAlias,
}: KeywordMetaDataProps): PageMetaDataValues {
  const metaTitle = `Latest ${capitalize(tagName)} | Beritaharian`;
  const metaDescription = `${tagName} News - Find latest News & top stories about ${tagName}.`;

  const metaTags: MetaTagsProps = {
    title: metaTitle,
    description: metaDescription,
    slug: `/tags/${tagAlias}`,
    ogImage: {
      url: getSectionOgImageUrl("default"),
      width: DEFAULT_OG_IMAGE_WIDTH,
      height: DEFAULT_OG_IMAGE_HEIGHT,
    },
  };

  const gaData: GADataProps = {
    chapter1: tagName,
    level2: "keywords",
    title: `${tagName}_Index`,
    section: "keywords",
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
